import { render, staticRenderFns } from "./AppAgroSettingsCard.vue?vue&type=template&id=0042f0a2&scoped=true&"
import script from "./AppAgroSettingsCard.vue?vue&type=script&lang=js&"
export * from "./AppAgroSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./AppAgroSettingsCard.vue?vue&type=style&index=0&id=0042f0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042f0a2",
  null
  
)

export default component.exports